import { render, staticRenderFns } from "./SubBiddersView.vue?vue&type=template&id=76f59630&"
import script from "./SubBiddersView.vue?vue&type=script&lang=js&"
export * from "./SubBiddersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
installComponents(component, {VBtn,VCard})
